define(function(require,exports,module){
	return function (num) {
        return (num).toFixed(8) * 1;
    }
});
